const getINRTotal = (total, INRVal) => {
  const totalAmount = total * INRVal;
  return totalAmount;
};

export default getINRTotal;
